<template>
  <transition name="fade">
    <component :is="currentComponent" />
  </transition>
</template>

<script>
import Members from './Members.vue';
import MemberDetailsVue from './MemberDetails.vue';
import SolutionDetailsVue from './SolutionDetails.vue';

export default {
  data() {
    return {
      currentComponent: this.decideComponent(),
    };
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler() {
        this.currentComponent = this.decideComponent();
      }
    }
  },
  methods: {
    decideComponent() {
      const { sid } = this.$route.query;
      if (sid) {
        return SolutionDetailsVue;
      } else {
        this.$router.push({
          path: `/404`,
        });
      }
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>